const pendingAutostarts = new Set<string>();

export function queueTerminalFrameAutostart(frameId: string) {
  pendingAutostarts.add(frameId);
}

export function consumeTerminalFrameAutostart(frameId: string): boolean {
  const shouldStart = pendingAutostarts.has(frameId);
  pendingAutostarts.delete(frameId);
  return shouldStart;
}
